import { render } from "./RubThb.vue?vue&type=template&id=1951a4b8"
import script from "./RubThb.vue?vue&type=script&lang=js"
export * from "./RubThb.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__